import { useState } from "react";
import { IoMdArrowDropright, IoMdArrowDropdown } from "react-icons/io";
import ProductDisplayProduct from "./ProductDisplayProduct";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { agreedProductsByMallId } from "./data";
import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import RoleAccess from "../../../function/RoleAccess";

const ProductDisplayMall = ({
  marketName,
  id,
  address,
  contactPerson,
  contactNumber,
  contractStart,
  contractEnd,
  completeWithin,
  status,
  agreedProducts = [],
  agreenProductOpen,
  setAgreenProductOpen,
  remarksOpen,
  setRemarksOpen,
  setDatas,
  datas,
  handleDeleteMall,
  tabValue,
  handleRecoildialog,
  agentCode,
  agentName,
}) => {
  const [productOpenStatus, setProductOpenStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [productData, setProductData] = useState([]);
  const navigate = useNavigate();

  const fetchMallProductData = async (mallId) => {
    setIsLoading(true);
    try {
      const response = await request(BASEURL, agreedProductsByMallId, {
        mallId,
      });

      const success = response?.agreedProductsByMallId?.success;
      if (success) {
        setProductData(response?.agreedProductsByMallId?.data || []);
      } else {
        setProductData([]);
      }
    } catch (error) {
      setProductData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFetchclick = (mallId) => {
    setProductOpenStatus((prev) => {
      const newStatus = !prev;
      if (newStatus) {
        fetchMallProductData(mallId);
      }
      return newStatus;
    });
  };

  const handleEditMall = (e) => {
    e.stopPropagation();
    navigate(`/product-compliance/form`, {
      state: {
        type: "edit",
        id,
      },
    });
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    handleDeleteMall(id);
  };

  return (
    <tbody className={`mall-table-group ${productOpenStatus ? "expanded" : ""}`}>
      <tr className="mall-row-main" onClick={() => handleFetchclick(id)}>
        <td className="mall-td-market">
          <div className="market-cell-content">
            <span className="expand-arrow-icon">
              {productOpenStatus ? (
                <IoMdArrowDropdown size={20} color="#2a9941" />
              ) : (
                <IoMdArrowDropright size={20} color="#666" />
              )}
            </span>
            <span className="market-name-text" title={marketName}>
              {marketName || "N/A"}
            </span>
          </div>
        </td>
        <td className="mall-td-code">{agentCode || "N/A"}</td>
        <td className="mall-td-agent">{agentName || "N/A"}</td>
        <td className="mall-td-date">{contractStart || "N/A"}</td>
        <td className="mall-td-date">{contractEnd || "N/A"}</td>
        <td className="mall-td-date">{completeWithin || "N/A"}</td>
        <td
          className="mall-td-actions"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="action-buttons-group">
            {tabValue !== "myentry" && (
              <>
                <RoleAccess
                  modelName="Product Display Compliance Screen"
                  component="UpdateProductCompliance"
                >
                  <Tooltip title="Edit Mall Entry">
                    <IconButton
                      size="small"
                      onClick={handleEditMall}
                      className="action-icon-btn edit-btn"
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </RoleAccess>

                <RoleAccess
                  modelName="Product Display Compliance Screen"
                  component="DeleteProductCompliance"
                >
                  <Tooltip title="Delete Mall Entry">
                    <IconButton
                      size="small"
                      onClick={handleDeleteClick}
                      className="action-icon-btn delete-btn"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </RoleAccess>
              </>
            )}
          </div>
        </td>
      </tr>

      {productOpenStatus && (
        <tr className="mall-row-expanded">
          <td colSpan={7} className="expanded-details-cell">
            <div className="expanded-content-wrapper">
              <ProductDisplayProduct
                agreedProducts={productData}
                contractStart={contractStart}
                contractEnd={contractEnd}
                completeWithin={completeWithin}
                address={address}
                isLoading={isLoading}
                agreenProductOpen={agreenProductOpen}
                setAgreenProductOpen={setAgreenProductOpen}
                remarksOpen={remarksOpen}
                setRemarksOpen={setRemarksOpen}
                setDatas={setDatas}
                datas={datas}
                handleDeleteMall={handleDeleteMall}
                mallId={id}
                tabValue={tabValue}
                handleRecoildialog={handleRecoildialog}
                contactNumber={contactNumber}
                contactPerson={contactPerson}
              />
            </div>
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default ProductDisplayMall;

